module.exports={render:function (){with(this) {
  return _h('a', {
    staticClass: "item ",
    class: ['item-' + theme, itemCls]
  }, [_t("item-left"), " ", _h('div', {
    staticClass: "item-inner"
  }, [_h('div', {
    staticClass: "input-wrapper"
  }, [_t("ion-label"), " ", _h('ion-label', {
    ref: "label"
  }, [_t("default")]), " ", _t("item-content")]), " ", _t("item-right")]), " ", _m(0)])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "button-effect"
  })
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9ca53cc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/item/src/item.vue
// module id = 165
// module chunks = 0